import { Box, Button } from "@material-ui/core";
import AddIcon from "@material-ui/icons/Add";
import { FC } from "react";
import { Datagrid, List, ListProps, TextField } from "react-admin";
import { useHistory } from "react-router-dom";

import CustomPagination from "../../components/CustomPagination";
import EmptyDataText from "../../components/EmptyDataText";
import TimestampField from "../../components/TimestampField";
import { AppResource } from "../../types/resource.types";
import ListPercentValue from "./components/ListPercentValue";
import ListPrice from "./components/ListPrice";
import ProductsDelete from "./components/ProductsActions/ProductsDelete";
import ProductsFilters from "./components/ProductsFilter";

const ProductsList: FC<ListProps> = (props) => {
  const { push } = useHistory();

  return (
    <>
      <Box>
        <Button
          variant="contained"
          color="primary"
          startIcon={<AddIcon />}
          onClick={() => push(`/${AppResource.bulkProductsCreate}`)}
        >
          Bulk Create
        </Button>
      </Box>
      <List
        {...props}
        sort={{ field: "createdAt", order: "desc" }}
        filters={<ProductsFilters />}
        pagination={<CustomPagination />}
        bulkActionButtons={false}
        exporter={false}
      >
        <Datagrid rowClick="edit" empty={<EmptyDataText message="No products yet!" />}>
          <TextField source="title.en" label="Title" sortable={false} />
          <ListPrice source="priceAfterDiscount" label="Price" sortable={false} />
          <ListPercentValue source="discountPercentage" label="Discount (%)" sortable={false} />
          <TextField source="totalItems" label="Total Quantity" />
          <TextField source="views" label="Views" sortable={false} />
          <TimestampField source="createdAt" label="Created At" />
          <ProductsDelete />
        </Datagrid>
      </List>
    </>
  );
};

export default ProductsList;
